import { createSimpleFunctional } from '@/util'

export const VBannerText = createSimpleFunctional('v-banner-text')
